module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-pow-can.b625041.jpg";